import Login from "@/views/login.vue";
import Allgemein from "@/views/01-allgemein.vue";
import Design from "@/views/02-inhalt.vue";
import Daten from "@/views/04-daten.vue";
import Auspraegung from "@/views/03-auspraegung.vue";
import FormularAuswahl from "@/views/00-formulartyp-auswahl.vue";

import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { MY_JLS_TOKEN } from "@/constants/local-storage-keys";
import FinishOrder from "@/views/05-finish-order.vue";

Vue.use(VueRouter);

console.log("ENV: ", process.env);

export const HOME_ROUTE_NAME = "Home";
export const START_ROUTE_NAME = "Start";
export const LOGIN_ROUTE_NAME = "Login";
export const FORMULAR_AUSWAHL_ROUTE_NAME = "FormularAuswahl";
export const ALLGEMEIN_ROUTE_NAME = "Allgemein";
export const DESIGN_ROUTE_NAME = "Design";
export const DATEN_ROUTE_NAME = "Daten";
export const AUSPRAEGUNG_ROUTE_NAME = "Auspraegung";
export const FINISH_ORDER = "FinishOrder";

const routes: Array<RouteConfig> = [
  {
    // root path
    path: "/",
    name: HOME_ROUTE_NAME,
    component: Login,
  },
  {
    // starting path
    path: "*",
    name: START_ROUTE_NAME,
    component: Login,
  },
  {
    path: "/login",
    name: LOGIN_ROUTE_NAME,
    component: Login,
  },
  {
    path: "/auswahl",
    name: FORMULAR_AUSWAHL_ROUTE_NAME,
    component: FormularAuswahl,
  },
  {
    path: "/allgemein",
    name: ALLGEMEIN_ROUTE_NAME,
    component: Allgemein,
  },
  {
    path: "/inhalt",
    name: DESIGN_ROUTE_NAME,
    component: Design,
  },
  {
    path: "/daten",
    name: DATEN_ROUTE_NAME,
    component: Daten,
  },
  {
    path: "/auspraegung",
    name: AUSPRAEGUNG_ROUTE_NAME,
    component: Auspraegung,
  },
  {
    path: "Abschluss",
    name: FINISH_ORDER,
    component: FinishOrder,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

function checkAuthentication(): boolean {
  // TODO make token to object in local storage
  if (localStorage.getItem(MY_JLS_TOKEN) !== null) {
    return true;
    // const token = localStorage.getItem(MY_JLS_TOKEN);
    // const token_expiration_date = new Date(token.created).getTime() / 1000;
    // // if (exp.date + ttl) < current date => token is still valid
    // if (token_expiration_date + token.ttl < Date().now()) {
    //   return true;
    // }
  }

  // else token not valid
  return false;
}

router.beforeEach((to, from, next) => {
  const isAuthenticated = checkAuthentication();
  if (to.name !== "Login" && !isAuthenticated) {
    next({ name: LOGIN_ROUTE_NAME });
  } else {
    next();
  }
});

export default router;
